// extracted by mini-css-extract-plugin
export default {"wrapper":"guide-viewer__wrapper__S4bR_","iframe":"guide-viewer__iframe__MfYGr","closeBtn":"guide-viewer__closeBtn__I9Ant"};